export const loadEquipmentList = [
  { id: "Van", value: "Van" },
  { id: "Reefer", value: "Reefer" },
  { id: "Flat", value: "Flat" },
  { id: "Van or Reefer", value: "Van or Reefer" },
  { id: "Rail", value: "Rail" },
  { id: "Auto", value: "Auto" },
  { id: "Double Drop", value: "Double Drop" },
  { id: "End Dump", value: "End Dump" },
  { id: "Flat with Tarps", value: "Flat with Tarps" },
  { id: "Flatbed or Van", value: "Flatbed or Van" },
  { id: "Flatbed, Van or Reefer", value: "Flatbed, Van or Reefer" },
  { id: "Flatbed with Sides", value: "Flatbed with Sides" },
  { id: "Hopper Bottom", value: "Hopper Bottom" },
  { id: "Hotshot", value: "Hotshot" },
  { id: "Lowboy", value: "Lowboy" },
  { id: "Maxi", value: "Maxi" },
  { id: "Power Only", value: "Power Only" },
  { id: "Reefer w/ Pallet Exchange", value: "Reefer w/ Pallet Exchange" },
  { id: "Removable Gooseneck", value: "Removable Gooseneck" },
  { id: "Step Deck", value: "Step Deck" },
  { id: "Tanker", value: "Tanker" },
  { id: "Curtain Van", value: "Curtain Van" },
  { id: "Flatbed Hazardous", value: "Flatbed Hazardous" },
  { id: "Reefer Hazardous", value: "Reefer Hazardous" },
  { id: "Van Hazardous", value: "Van Hazardous" },
  { id: "Vented Van", value: "Vented Van" },
  { id: "Van w/ Pallet Exchange", value: "Van w/ Pallet Exchange" },
  { id: "B-Train", value: "B-Train" },
  { id: "Container", value: "Container" },
  { id: "Double Flat", value: "Double Flat" },
  { id: "Flatbed or Stepdeck", value: "Flatbed or Stepdeck" },
  { id: "Air", value: "Air" },
  { id: "Ocean", value: "Ocean" },
  { id: "Walking Floor", value: "Walking Floor" },
  { id: "Landoll Flatbed", value: "Landoll Flatbed" },
  { id: "Conestoga", value: "Conestoga" },
  { id: "Load Out", value: "Load Out" },
  { id: "Van Air-Ride", value: "Van Air-Ride" },
  { id: "Container Hazardous", value: "Container Hazardous" },
  { id: "Vented Van or Reefer", value: "Vented Van or Reefer" },
  { id: "Cargo Van", value: "Cargo Van" },
];
